import React from "react";

import { Button, Group, Page } from "@samskip/frontend-components";
import { PageProps, navigate } from "gatsby";
import { useTranslation } from "react-i18next";

import { NavigationConstants } from "@assets/constants";
import { useAppSelector } from "@assets/hooks";
import { userProfileState } from "@state/slices/userProfileSlice";

type DomesticSuccessProps = PageProps<
  null,
  null,
  { bookingNumber?: string; isKioskMode?: boolean }
>;

const DomesticSuccess = ({ location }: DomesticSuccessProps) => {
  const bookingNumber = location?.state?.bookingNumber || null;
  const isKioskMode = location?.state?.isKioskMode || false;
  const { userProfile } = useAppSelector(userProfileState);

  const { t } = useTranslation();

  if (!bookingNumber) {
    // Not sure it's the best idea to pass in the search query, but at this moment I have no other idea how to pass in the no layout for the kiosk...
    navigate(
      `${NavigationConstants.NAVIGATION_LINKS.domestic}/create${location.search}`,
      {
        replace: true,
      }
    );
  }
  return (
    <Page
      noTitleUnderline
      size="medium"
      title={t("TEXT_BOOKING_N_CREATED", {
        n: bookingNumber,
      })}
    >
      <div className="flex flex-col gap-6">
        <Group>
          <Button
            onClick={() =>
              // Not sure it's the best idea to pass in the search query, but at this moment I have no other idea how to pass in the no layout for the kiosk...
              navigate(`/domestic/labels/${bookingNumber}${location.search}`, {
                replace: true,
              })
            }
          >
            {t("LABEL_PRINTBARCODES")}
          </Button>
          <Button
            onClick={() =>
              isKioskMode
                ? navigate(
                    `${NavigationConstants.NAVIGATION_LINKS.domestic}/create/kiosk${location.search}`,
                    {
                      replace: true,
                    }
                  )
                : navigate(
                    `${NavigationConstants.NAVIGATION_LINKS.domestic}/create${location.search}`,
                    {
                      replace: true,
                    }
                  )
            }
            variant="secondary"
          >
            {t("LABEL_CREATE_NEW_BOOKING")}
          </Button>
        </Group>
        {userProfile && <p>{t("TEXT_BARCODES_PRINT_LATER")}</p>}
      </div>
    </Page>
  );
};

export default DomesticSuccess;
